import React, {useState} from 'react'
import {Box, BoxProps, HStack, Table, Thead, Tbody, Tr, Th, Td, Text, VStack, useMultiStyleConfig} from '@chakra-ui/react'
import {Button} from '_uiComponents'
import {SizeGuideSection} from '_types'

interface SizeGuideTableProps {
    section: SizeGuideSection
}

const SizeGuideTable = ({section}: SizeGuideTableProps) => {
    const [activeTableId, setActiveTableId] = useState(section.tables[0]?.id)
    const styles = useMultiStyleConfig('SizeGuide', {}) as Record<string, BoxProps>

    return (
        <VStack align="stretch">
            {!section.hideTableSwitch && (
                <HStack sx={styles.tableSwitchWrapper}>
                    {section.tables.map((table) => (
                        <Button
                            key={table.id}
                            variant={table.id === activeTableId ? 'primary' : 'outlineLight'}
                            sx={styles.tableSwitchButton}
                            onClick={() => setActiveTableId(table.id)}
                        >
                            {table.name}
                        </Button>
                    ))}
                </HStack>
            )}

            {section.tables
                .filter((table) => table.id === activeTableId)
                .map((table) => (
                    <Box sx={styles.tableWrapper} key={table.id}>
                        {table.headerNotes && <Text sx={styles.headerNotes}>{table.headerNotes}</Text>}

                        <Table sx={styles.table}>
                            <Thead>
                                <Tr sx={styles.tableHeaderRow}>
                                    {table.headers.map((header, index) => (
                                        <Th key={index} sx={styles.tableHeaderCell}>
                                            {header.name && (
                                                <Text sx={styles.tableHeaderNation} as="span">
                                                    {header.name}
                                                </Text>
                                            )}
                                            <Text sx={{...styles.tableHeaderNationDesc, ...(index === 0 ? styles.tableHeaderNationDescTitle : {})}} as="span">
                                                {header.text.toLocaleLowerCase()}
                                            </Text>
                                        </Th>
                                    ))}
                                </Tr>
                            </Thead>
                            <Tbody>
                                {table.items.map((row, rowIndex) => (
                                    <Tr key={rowIndex} sx={styles.tableRow}>
                                        {row.map((cell, cellIndex) => (
                                            <Td key={cellIndex} sx={{...styles.tableCell, ...(cellIndex === 0 ? styles.tableCellTitle : {})}}>
                                                <Text as="span">{cell}</Text>
                                            </Td>
                                        ))}
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </Box>
                ))}

            {section.footerNotes && <Text sx={styles.footerNotes}>{section.footerNotes}</Text>}
        </VStack>
    )
}

export default SizeGuideTable
